const leadViews = {
  tax_roll: "tax_roll",
  leases: "leases",
};

export { leadViews };
